import * as React from 'react';
import { useContext } from 'react';
import { useTranslation } from 'next-i18next';
import ControlSelect from 'ap-admin-components/lib/Components/ControlSelect';
import { AuthContext } from '@/auth/Authentication';
import { ChannelContext } from '@/components/channel/Channel';
import { translationNamespace } from '@/lib/config';
import styles from '@/layout/header/styles.module.scss';

const ChannelSelect: React.FC = () => {
  const { t } = useTranslation(translationNamespace);
  const { isAuthenticated } = useContext(AuthContext);
  const { channelId, channels, selectChannel } = useContext(ChannelContext);

  if (!isAuthenticated || !channels.length) {
    return null;
  }

  return (
    <div className={styles['header__channels']}>
      <label>{t('common.channel')}:</label>
      <ControlSelect
        value={channelId}
        onChange={(e) => selectChannel(e.target.value)}
      >
        {channels.map((opt, index) => (
          <option
            key={index}
            value={opt.id}
          >
            {opt.label}
          </option>
        ))}
      </ControlSelect>
    </div>
  );
};

export default ChannelSelect;
